import { render, staticRenderFns } from "./carousel.vue?vue&type=template&id=56bbe0c0&scoped=true&"
import script from "./carousel.vue?vue&type=script&lang=js&"
export * from "./carousel.vue?vue&type=script&lang=js&"
import style0 from "./carousel.vue?vue&type=style&index=0&id=56bbe0c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bbe0c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56bbe0c0')) {
      api.createRecord('56bbe0c0', component.options)
    } else {
      api.reload('56bbe0c0', component.options)
    }
    module.hot.accept("./carousel.vue?vue&type=template&id=56bbe0c0&scoped=true&", function () {
      api.rerender('56bbe0c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/ItemConfig/carousel.vue"
export default component.exports